"use client";
import { jsx, Fragment } from 'react/jsx-runtime';
import { createContext, useState, useEffect, useContext } from 'react';
import { logger } from './Debug.js';

const context = createContext({
    isHydrating: false,
});
context.displayName = 'NinjaPersistor';
const NinjaPersistorProvider = ({ children, persistor }) => {
    const [isBootStrapped, setIsBootStrapped] = useState(false);
    useEffect(() => {
        logger.log('[NinjaPersistorProvider][useEffect[]]', {
            isHydrating: !isBootStrapped,
        });
        if (persistor.getState().bootstrapped) {
            setIsBootStrapped(true);
        }
        else {
            const unsubscribe = persistor.subscribe(() => {
                setIsBootStrapped(persistor.getState().bootstrapped);
            });
            return unsubscribe;
        }
    }, []);
    return jsx(context.Provider, { value: { isHydrating: !isBootStrapped }, children: children });
};
const PersistorSuspense = ({ children, loading }) => {
    const { isHydrating } = useContext(context);
    if (!isHydrating)
        return jsx(Fragment, { children: children });
    return jsx(Fragment, { children: loading });
};
const usePersistorState = () => {
    const { isHydrating } = useContext(context);
    return {
        isHydrating,
    };
};

export { NinjaPersistorProvider, PersistorSuspense, usePersistorState };
